import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'


export const querytableColumngroupProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
})

export type QuerytableColumngroupProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumngroupProps>>>

export default defineComponent({
  name: 'OQuerytableColumngroup',
  inheritAttrs: false,
  props: querytableColumngroupProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
